import { inject, Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';

import { MilestoneState, MilestoneStore } from './milestone.store';
import { TimelineQuery } from './timeline.query';

@Injectable({ providedIn: 'root' })
export class MilestoneQuery extends QueryEntity<MilestoneState> {
  private timelineQuery = inject(TimelineQuery);

  protected store: MilestoneStore;

  constructor() {
    const store = inject(MilestoneStore);

    super(store);

    this.store = store;
  }
}
